<template>
  <div>
    <Header/>
    <router-view/>
    <Footer v-if="$route.name != 'Home'"/>
  </div>
</template>

<script>
  import Header from './components/Header'
  import Footer from './components/Footer'
  export default {
    name: 'App',
    components: {
      Header,
      Footer
    },
  }
</script>

<style>
  @import url('https://fonts.googleapis.com/css2?family=Saira+Condensed:wght@600;700&display=swap');
  @import url("https://use.typekit.net/crg1jcz.css");

  *{
    margin: 0;
    padding: 0;
    font-family: 'sofia-pro', sans-serif!important;
    font-weight: 400;
    color: #171717;
  }
  body{
    /* background-color: #171717!important; */
  }
  .content{
    width: 85%;
    margin: 0 auto;
  }
  h2, h2 span{
    font-family: 'Saira Condensed', sans-serif!important;
    font-weight: 600!important;
    margin: 0!important;
  }
  h3, h3 span{
    font-family: 'Saira Condensed', sans-serif!important;
    font-weight: 600!important;
    margin: 0!important;
    text-transform: uppercase;
    font-size: 38px!important;
  }
  h3 span{
    color: #EC4802;
  }
  .btn{
    background-color: #EC4802!important;
    color: white!important;
    border-radius: inherit!important;
    border: none!important;
    text-transform: uppercase;
    font-size: 10pt!important;
    padding: 8px!important;
  }
  .btn:active{
    box-shadow: none!important;
  }
  .ancla{
    position: absolute;
    top: -65.04px;
  }
  .ancla2{
    position: absolute;
    top: -165.04px;
  }
  .body::before{
    content: '';
    display: block;
    height: 65.04px;
  }

  @media screen and (max-width: 767px){
    .content{
      width: 90%;
    }
    h3, h3 span{
      font-size: 24pt!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue